export { default } from '@/features/pos/pages/ProductCatalogPage'
